<template>
	<div class="flex flex-wrap w-full">
		<div class="hidden lg:block w-8/12">
			<div class="relative">
				<div
						class="bg-no-repeat bg-contain absolute inset-0 z-0"
						:style="[background.length ? { backgroundImage:`url(${background})`}: {}]">

				</div>
				<div
						class="absolute bg-no-repeat bg-contain inset-0 z-10 ease-linear transition-all duration-500"
						:style="[active >= 0 ? { backgroundImage:`url(${locations[active].industry.map})`}: {}]"
				>
				</div>
				<img class="invisible" v-if="background.length" :src="background" />
			</div>

		</div>
		<div class="w-full lg:w-4/12">
			<div class="border-t border-hamlet-purple">
				<div
						class="border-b border-hamlet-purple"
						v-for="(location, index) in locations" :key="index+'lc'">
					<div @click="setActive(index)" class="flex items-center pt-3.5 pb-2.5">
						<h6 class="uppercase ml-2 text-hamlet-purple">{{ location.industry.title }}</h6>
						<svg
								class="ml-auto transform mb-1"
								:class="active === index ?'rotate-90':'rotate-0'"
								width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.18538 4.99338L-5.34058e-05 -4.26112e-07L9.74829 4.99338L-5.38429e-05 10L2.18538 4.99338Z" fill="#672240"/>
						</svg>
					</div>
					<div
							:class="active === index ?'max-h-96 mb-10':'max-h-0'"
							class="overflow-hidden ease-linear transition-all duration-500 pl-2 amenity-block"
							v-html="location.items"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "amenity-map",
	props: {
		locations: {
			type: Array,
			default: () => []
		},
		background: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			active: -1
		}
	},
	methods: {
		setActive(index){
			if(index === this.active){
				this.active = -1;
				return;
			}
			this.active = index;
		}
	},
	computed: {

	}
}
</script>

<style scoped>

</style>
